<div class="input-main-container ym-display-flex ym-flex-direction-column ym-gap-2" [class.error-occured]="error">
    <div class="label-container ym-display-flex ym-align-items-center ym-gap-3" *ngIf="showLabel">
        <div class="ym-text-color ym-display-flex ym-align-items-center ym-gap-2 ym-w-full">
            <span class="text ym-font-base ym-line-height-normal">{{label}}</span>
            <span class="optional-indicator ym-text-secondary ym-display-inline-block" *ngIf="!required && !hideOptional">
                <!-- <span class="icon ym-svg-sm ym-mt-n2">
                    <ym-icon [iconName]="iconNames.REQUIRED"></ym-icon>
                </span> -->
                (optional)
            </span>
            <span class="inline-info ym-svg-base" *ngIf="inlineInfo">
                <ym-inline-info [hideTooltip]="true">
                    {{inlineInfo}}
                </ym-inline-info>
            </span>
        </div>
    </div>
    <!-- Show search when options are 8 or more -->
    <ym-dropdown [showDropdown]="isDropdownOpen" [dismissOnSelect]="false" [searchable]="options.length > 7" (search)="search($event)"
        (onDropdownClose)="toggleDropdown(false)" (selectedOption)="selectedOption($event)"
        [selectionType]="dropdownSelectionTypes.CHECKBOX" [position]="popoverPositions.BELOW_LEFT_START"
        [dropdownOption]="filteredDropdownOptions" class="ym-w-full">
        <ng-container trigger>
            <ym-button [fullWidth]="true" [variant]="buttonVariants.DROPDOWN" [disabled]="disabled" (onClick)="toggleDropdown(true)"
                class="ym-w-full">
                {{selectedOptionLabel}}
            </ym-button>
        </ng-container>
    </ym-dropdown>
    <span class="error-text ym-font-sm ym-text-danger ym-display-block ym-line-height-normal"
        *ngIf="error">{{errorText}}</span>
</div>